import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const TeamMembersApi = createApi({
  reducerPath: "teamMemberApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getReporteesList: builder.query({
      query: ({ userId, pageNumber, userName, artifactNames }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchReporteesActivityCount(
              request: { 
                supervisorid: "${userId}",
                userName: "${userName}",
                artifactNames:${artifactNames ? `["${artifactNames}"]` : "[]"}
              }
              criteria: {
                sortKey: "email"
                order: "ASC"
                pageNo: ${pageNumber}
                pageCount: 10
              }
            ) {
              timestamp
              version
              error
              data {
                myReportees {
                  userId
                  name {
                    fullName
                  }
                  email
                  profileImageUrl
                  employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }
                  skills {
                    skillName
                    skillId
                    proficiency
                    verified
                  }
                  assignments {
                    artifactId
                    artifactType
                    title
                    shortDescription
                    longDescription
                    language
                    duration
                    difficultyLevel
                    branding {
                      banner
                      thumbnail
                      promo
                    }
                    sourceName
                    sourceType
                    prerequisite
                    learningObjective
                    demonstrableOutcome
                    brandingurls {
                      banner
                      thumbnail
                      promo
                    }
                    searchTags {
                      defaultTag
                    }
                    weblink
                    progressPercentage
                    progressStatus
                  }
                  assigned
                  selfLearning
                  inProgress
                  completed
                }
                pageNumber
                pageSize
                totalCount
              }
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs?.arg?.pageNumber > 0) {
          const messageMap = new Map();
          [
            ...currentCacheData.fetchReporteesActivityCount.data.myReportees,
            ...responseData.fetchReporteesActivityCount.data.myReportees
          ].map((msg) => {
            if (!messageMap.has(msg.userId)) {
              messageMap.set(msg.userId, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            fetchReporteesActivityCount: {
              ...responseData.fetchReporteesActivityCount,
              data: {
                ...responseData.fetchReporteesActivityCount.data,
                myReportees: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const { useGetReporteesListQuery, useLazyGetReporteesListQuery } =
  TeamMembersApi;
